import { stateMachine } from '@root/src/states/machine/state-machine';
import { state as initState } from '@src/states/init';
import { state as gameState } from '@src/states/game';
import { state as ballSpinState } from '@root/src/states/ball-spin';
import { state as wheelOfFortuneState } from '@src/states/wheel-of-fortune';
import { state as cashReelsState } from '@src/states/cash-reels';
import { state as plinkoState } from '@src/states/plinko';
import { state as bigWinState } from '@src/states/big-win';
import { state as cashReelsDouble } from '@src/states/cash-reels-double';
import { state as wheelOfFortuneDouble } from '@src/states/wheel-of-fortune-double';

const gameStates = [
    initState,
    gameState,
    ballSpinState,
    wheelOfFortuneState,
    wheelOfFortuneDouble,
    cashReelsState,
    cashReelsDouble,
    plinkoState,
    bigWinState
];

export function initGameStates() {
    stateMachine.states = gameStates;
    stateMachine.start();
}
